// import React, { Component, useContext, useState, useEffect, useMemo } from 'react'
import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import { PropTypes } from 'prop-types'

import auth from '../../components/common/Auth';

import { Button, Card, Col, Container, Row } from 'react-bootstrap'

import { PageHeaderStandar } from '../../components/common/PageHeaderStandar';
import { useSelector } from 'react-redux';
import languageData from "../../data/languageData";

export const UserSettings = (props, context) => {

  const user = auth.getSessionUser();

  // const { i18nState } = useSelector(state => state.i18nState);
  const { lang } = useSelector(state => state.i18nState);

  const langSelected = languageData(lang);
                
  return (
    <div>
        <Container fluid className="main-content-container px-4">
        <PageHeaderStandar title={context.t('Settings')} subtitle={context.t('User')} />
            <br/>
            <Row>
              <Col lg="4">
                <Card className="mb-4 pt-3 border-bottom text-center">
                  <div className="mb-3 mx-auto">
                    <i className="material-icons blue-text" style={{fontSize: "50px"}}>password</i>
                  </div>
                  <h4 className="mb-0">{context.t('Password')}</h4>
                  <p className="text-muted d-block mb-2">********</p>
                  <hr/>
                  <Link to={'/settings/password'}>
                      <Button size="sm" className="mb-2 btn btn-outline-primary btn-sm btn-pill">
                        <i className="material-icons mr-1">edit</i> {context.t('Change Password')}
                      </Button>
                  </Link>
                </Card>
              </Col>
              <Col lg="4">
                <Card className="mb-4 pt-3 border-bottom text-center">
                  <div className="mb-3 mx-auto">
                    <i className="material-icons blue-text" style={{fontSize: "50px"}}>email</i>
                  </div>
                  <h4 className="mb-0">{context.t('Email')}</h4>
                  <p className="text-muted d-block mb-2">{user.email}</p>
                  <hr/>
                  <Link to={'/settings/email'}>
                    <Button size="sm" className="mb-2 btn btn-outline-primary btn-sm btn-pill">
                      <i className="material-icons mr-1">edit</i> {context.t('Change Email')}
                    </Button>
                  </Link>
                </Card>                
              </Col>
              <Col lg="4">
                <Card className="mb-4 pt-3 border-bottom text-center">
                  <div className="mb-3 mx-auto">
                    <i className="material-icons blue-text" style={{fontSize: "50px"}}>translate</i>
                  </div>
                  <h4 className="mb-0">{context.t('Language')}</h4>
                  <p className="text-muted d-block mb-2">{ langSelected[0].name }</p>
                  <hr/>
                  <Link to={'/settings/language'}>
                    <Button size="sm" className="mb-2 btn btn-outline-primary btn-sm btn-pill">
                      <i className="material-icons mr-1">edit</i> {context.t('Change Language')}
                    </Button>
                  </Link>
                </Card>
              </Col>
            </Row>
      </Container>
    </div>
  )
}

UserSettings.contextTypes = {
    t: PropTypes.func
}

export default UserSettings;

